import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfig, isFirebaseConfigured } from '@/config/firebase.config';

// Validate required config
if (!isFirebaseConfigured()) {
  console.warn('⚠️ Firebase not properly configured');
  console.warn('⚠️ Please set up your Firebase environment variables');
  console.warn('⚠️ Firebase features will be disabled');
}

// Initialize Firebase
let app: any = null;
let messaging: any = null;
let firestore: any = null;
let messagingSupported = false;

try {
  app = initializeApp(firebaseConfig);
  firestore = getFirestore(app);
  
  // Check if messaging is supported in this environment
  isSupported().then((supported) => {
    messagingSupported = supported;
    if (supported && app) {
      messaging = getMessaging(app);
      console.log('✅ Firebase messaging initialized');
    } else {
      console.warn('⚠️ Firebase messaging not supported in this environment');
    }
  });
  
  console.log('✅ Firebase app initialized');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
}

export { app, messaging, firestore, messagingSupported };
export { getToken, onMessage };
